export function resolveNextAction({
  dueCount,
  hasShownUpToday,
  hasActionCompletionToday = false,
  hasTrustBud,
  onChooseAction,
  onCheckIn,
  onSendUpdate,
  onOpenPlan,
  onOpenSprint,
}) {
  const partnerMessageLabel = "Check in with your TrustBud";

  if (dueCount > 0) {
    return {
      primary: {
        label: hasActionCompletionToday ? "Do one more" : "Do one habit",
        onClick: onChooseAction,
      },
      secondary: hasTrustBud
        ? {
            label: partnerMessageLabel,
            onClick: onSendUpdate,
          }
        : {
            label: "Open Plan",
            onClick: onOpenPlan,
          },
    };
  }

  if (!hasShownUpToday) {
    return {
      primary: {
        label: "Check in",
        onClick: onCheckIn,
      },
      secondary: hasTrustBud
        ? {
            label: partnerMessageLabel,
            onClick: onSendUpdate,
          }
        : {
            label: "Open Plan",
            onClick: onOpenPlan,
          },
    };
  }

  if (hasTrustBud) {
    return {
      primary: {
        label: partnerMessageLabel,
        onClick: onSendUpdate,
      },
      secondary: {
        label: "Open Accountability",
        onClick: onOpenSprint,
      },
    };
  }

  return {
    primary: {
      label: "Open Plan",
      onClick: onOpenPlan,
    },
    secondary: null,
  };
}
